<template>
  <div ref="self" class="c-lbreak no-border">
    <div class="c-lbreak-unit c-lbreak-unit--brand" v-show="brand">
      <div :class="[ layoutType == 'archive' ? 't-h--13 t-h--16l' : 't-h--18']">
        <strong class="t--fak text-effect-txt c-lbreak-unit__txt">{{ brand }}</strong>
      </div>
    </div>
    <div class="c-lbreak-unit c-lbreak-unit--type" v-show="type">
      <div :class="[ layoutType == 'archive' ? 't-h--13 t-h--16l' : 't-h--18']">
        <span class="t--fak c-lbreak-unit__txt">
          <span class="t--ft">(</span>{{ type }}<span class="t--ft">)</span>
        </span>
      </div>
    </div>
    <div class="c-lbreak-unit c-lbreak-unit--date" v-show="year">
      <div :class="[ layoutType == 'archive' ? 't-h--13 t-h--16l' : 't-h--18']">
        <span class="t--fak c-lbreak-unit__txt">©{{ year }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "fxdom";
import * as _ from "fxjs";

import { ref, reactive, onMounted, onUnmounted, useStore } from "@/helper/vue.js";
import { isOverwrap } from "@/helper/gadget.js";

export default {
  props: {
    layoutType: {
      type: String
    },
		brand: {
      type: String
    },
    type: {
      type: String
    },
    client: {
      type: String
    },
    year: {
      type: String
    },
    noBorder: {
      type: Boolean,
      default: true
    },
    designGap: {
      type: Number,
      default: 20
    },
  },

	setup(props, context) {
		const self = ref();
		const { state, commit, dispatch } = useStore();
		const data = reactive({
		});

		let unitName = null;
		let unitType = null;
		let unitDate = null;

    const designGap = props.noBorder ? 9 : props.designGap;
    const decoBorderClass = 'deco-border';
    const decoBorder = `<span class="${decoBorderClass}"></span>`;

    const CB_LANDED = () => {
      unitName = $.qs(`.c-lbreak-unit--brand`, self.value);
      unitType = $.qs(`.c-lbreak-unit--type`, self.value);
      unitDate = $.qs(`.c-lbreak-unit--date`, self.value);

      setLine();
      window.addEventListener('changed.mq', cbResize);
    }
    const cbResize = () => {
      setLine();
    }

    // window.addEventListener('changed.mq', cbResize);

    const setLine = () => {
      const unitNameTxt = $.qs(`.c-lbreak-unit__txt`, unitName);
      const unitTypeTxt = $.qs(`.c-lbreak-unit__txt`, unitType);
      const unitDateTxt = $.qs(`.c-lbreak-unit__txt`, unitDate);

      let wrapWidth = self.value.getBoundingClientRect().width;
      let nameWidth = unitNameTxt.getBoundingClientRect().width;
      let typeWidth = unitTypeTxt.getBoundingClientRect().width;
      let dateWidth = unitDateTxt.getBoundingClientRect().width;
      let nameTypeWidth = nameWidth + typeWidth;

      if (self.value.querySelectorAll('.' + decoBorderClass).length) {
        _.go(
          $.findAll('.' + decoBorderClass, self.value),
          _.each(item => {
            $.remove(item);
          })
        );
      }
      $.removeClass('date-break type-break all-break', self.value);
      $.addClass('default-break', self.value);
      $.insertAfter(unitTypeTxt, $.el(decoBorder));

      if (isOverwrap(wrapWidth, nameTypeWidth + dateWidth, designGap)) {
        // $.removeClass('default-break', self.value);
        $.addClass('date-break', self.value);
        $.insertBefore(unitDateTxt, $.el(decoBorder));

        if (isOverwrap(wrapWidth, nameTypeWidth, designGap)) {
          $.removeClass('default-break', self.value);
          $.addClass('type-break', self.value);
          $.insertAfter(unitNameTxt, $.el(decoBorder));
          $.remove($.qs('.' + decoBorderClass, unitDate));

          if (isOverwrap(wrapWidth, typeWidth + dateWidth, designGap)) {
            $.addClass('all-break', self.value);
            $.insertBefore(unitDateTxt, $.el(decoBorder));
          }
        }
      }
    }

		onMounted(() => {
      if (state.pageState !== 'landed') {
        window.addEventListener('landed', CB_LANDED);
      } else {
        CB_LANDED();
      }
		});
		onUnmounted(() => {
      window.removeEventListener('changed.mq', cbResize);
      window.removeEventListener('landed', CB_LANDED);
    });

		return {
			self
		};
	}
}
</script>

<style lang="scss" scoped>
.c-lbreak {
  $self: &;
	display: flex;
	flex-wrap: wrap;
	width:100%;
  // overflow: hidden;
	&-unit {
		flex: auto;
		// overflow: hidden;
    position: relative;
		&--brand {
			flex-grow: 0;
		}
		&--date {
			flex-grow: 0;
		}
		&__txt {
			position:relative;
		}
		& > div {
			display:flex;
      width:100%;
      margin-left: 0;
      margin-right: 0;
		}
		.deco-border {
			flex: 1;
			bottom: 0;
			width: auto;
			margin:0 4px;
      border-bottom: 1px solid;
      // border-color: inherit;
		}
	}
  &.default-break {
    .c-lbreak-unit {
      white-space: nowrap;
      &--type {
        padding-left: 4px;
      }
    }
  }
	&.date-break {
		.c-lbreak-unit--type {
			& > div {
				display: block;
			}
			.deco-border {
				display: inline-block;
				position: absolute;
				width: 1000px;
			}
		}
		.c-lbreak-unit--date {
			width: 100%;
			.deco-border {
				margin:0 4px 0 0;
			}
		}
	}
	&.type-break {
		.c-lbreak-unit--brand {
			width: 100%;
			& > div {
				display: block;
			}
			.deco-border {
				display: inline-block;
				position: absolute;
				width: 1000px;
			}
		}
		.c-lbreak-unit--type {
			padding-left:0;
			& > div {
				display:flex;
				width:100%;
			}
			.deco-border {
				position:static;
				flex: 1;
				width: auto;
			}
		}
		.c-lbreak-unit--date {
			width: auto;
		}
	}
	&.all-break {
		.c-lbreak-unit--type {
			width: 100%;
			& > div {
				display: block;
			}
			.deco-border {
				display: inline-block;
				position: absolute;
				width: 1000px;
			}
		}
		.c-lbreak-unit--date {
			width:100%;
		}
	}
	&.no-border {
		.deco-border {
			visibility: hidden;
		}
	}
  &--hightlight {
    #{$self}-unit {
      &--brand {
        margin-left: 24em;
        margin-right: 24em;
        .__w600 & {
          margin-left: 12em;
          margin-right: 12em;
        }
        & > div {
          display: inline-block !important;
          width: auto;
        }
      }
      &--type {
        margin-left: 24em !important;
        .__w600 & {
          margin-left: 12em !important;
        }
      }
      &--date {
        margin-right: 24em;
        .__w600 & {
          margin-right: 12em;
        }
      }
    }
  }
}
.deco-border {
  .t-h--128 &{
    margin: 2em 35em;
  }
  .t-h--54 &{
    margin: 2em 4em;
  }
  .t-h--18 &,
  .t-h--16 &,
  .t-h--13 &,
  .t-h--11 & {
    margin: 2em 2em;
  }
}
</style>